import { Link } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';

interface LandingNavProps {
  signupEnabled: boolean;
  isDark: boolean;
  onThemeToggle: () => void;
}

/**
 * LandingNav Component
 *
 * Navigation bar for the landing page with:
 * - Logo
 * - Theme toggle
 * - Sign In link (when signup enabled)
 * - Get Started CTA or "Coming Soon" badge
 */
export function LandingNav({ signupEnabled, isDark, onThemeToggle }: LandingNavProps) {
  return (
    <nav className="landing-nav">
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--cld-spacing-sm)' }}>
        <img
          src="/assets/logo.png"
          alt="ClosedLoopDiving"
          className="landing-nav__logo"
        />
      </div>
      <div className="landing-nav__actions">
        <ThemeToggle isDark={isDark} onToggle={onThemeToggle} />
        {signupEnabled ? (
          <>
            <Link to="/signin" className="landing-nav__link">
              Sign In
            </Link>
            <Link to="/signup" className="landing-nav__cta">
              Get Started
            </Link>
          </>
        ) : (
          <span className="landing-nav__badge">Coming Soon</span>
        )}
      </div>
    </nav>
  );
}
